import { render, staticRenderFns } from "./WireList.vue?vue&type=template&id=06219718&"
import script from "./WireList.vue?vue&type=script&lang=js&"
export * from "./WireList.vue?vue&type=script&lang=js&"
import style0 from "./WireList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports